import axios from './BaseService';

const STRATEGIES_URL = `${process.env.REACT_APP_API_URL}/strategies/`;

export async function getAllStrategies(page = 1, search = '') {
    let url = `${STRATEGIES_URL}admin?page=${page}`;
    if (search) {
        url += `&search=${encodeURIComponent(search)}`;
    }
    const response = await axios.get(url);
    return response.data; // {count, rows}
}

export async function deleteStrategy(id) {
    const response = await axios.delete(`${STRATEGIES_URL}${id}`);
    return response.data;
}

export async function getOrphanStrategies() {
    const response = await axios.get(`${STRATEGIES_URL}orphans`);
    return response.data; // {count, rows}
}

export async function deleteOrphanStrategies() {
    const response = await axios.delete(`${STRATEGIES_URL}orphans`);
    return response.data;
}




